import { cittadinoService } from "@/_services";

const state = {
  unread: 0,
};

const actions = {
  // Aggiorna il conteggio delle risposte non lette del cittadino (badge menu).
  fetchUnread({ commit }) {
    return cittadinoService
      .getUnreadSegnalazioniCount()
      .then((response) => {
        const unread = response?.data?.data?.unread || 0;
        commit("setUnread", unread);
        return unread;
      })
      .catch(() => {
        commit("setUnread", 0);
        return 0;
      });
  },
};

const mutations = {
  setUnread(state, value) {
    state.unread = value;
  },
};

const getters = {
  unreadCount: (state) => state.unread,
};

export const segnalazioni = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
